import { TableColumn } from '@shared/interfaces';

/**
 * The columns for the licenses table in single screen view.
 */
export const LICENSE_COLUMNS: TableColumn[] = [
    { field: 'licenseKey', header: 'License Key', width: '250px' },
    { field: 'alias', header: 'Alias', width: '180px' },
    { field: 'internetType', header: 'Internet Type', width: '180px' },
    { field: 'internetSpeed', header: 'Internet Speed', width: '180px' },
    { field: 'createdBy', header: 'Created By', width: '180px' },
];

/**
 * Dummy license data matching the table columns from the screenshot.
 */
export const LICENSE_DATA = [
    {
        id: '1',
        licenseKey: 'Lorem Tag',
        alias: 'Lorem Alias',
        internetType: 'PLDT SUCKS',
        internetSpeed: '--',
        createdBy: 'Jose Rizal',
    },
    {
        id: '2',
        licenseKey: 'Lorem Tag',
        alias: 'Lorem Alias',
        internetType: 'PLDT SUCKS',
        internetSpeed: '--',
        createdBy: 'Jose Rizal',
    },
    {
        id: '3',
        licenseKey: 'Lorem Tag',
        alias: 'Lorem Alias',
        internetType: 'PLDT SUCKS',
        internetSpeed: '--',
        createdBy: 'Jose Rizal',
    },
    {
        id: '4',
        licenseKey: 'Lorem Tag',
        alias: 'Lorem Alias',
        internetType: 'PLDT SUCKS',
        internetSpeed: '--',
        createdBy: 'Jose Rizal',
    },
    {
        id: '5',
        licenseKey: 'Lorem Tag',
        alias: 'Lorem Alias',
        internetType: 'PLDT SUCKS',
        internetSpeed: '--',
        createdBy: 'Jose Rizal',
    },
];
